"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollToTop = void 0;

var _react = require("react");

var useScrollToTop = function useScrollToTop(pathname) {
  (0, _react.useEffect)(function () {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

exports.useScrollToTop = useScrollToTop;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useScrollToTop.js
// module id = 257
// module chunks = 209 210 211 212